const CameraHelper = {};
const rImageType = /data:(image\/.+);base64,/;

import LogManager from '../module/LogManager';

CameraHelper.b64toBlobAlt = (dataURI, contentType) => {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: contentType });
};

CameraHelper.base64ToBlob = data => {
    let mimeString = '';
    let raw, uInt8Array, i;

    raw = data.replace(rImageType, function(header, imageType) {
        mimeString = imageType;
        return '';
    });

    raw = atob(raw);
    const rawLength = raw.length;
    uInt8Array = new Uint8Array(rawLength); // eslint-disable-line
    for (i = 0; i < rawLength; i += 1) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: mimeString });
};
CameraHelper.setOptions = srcType => {
    const Camera = window.Camera;
    const options = {
        // Some common settings are 20, 50, and 100
        quality: 80,
        //destinationType: Camera.DestinationType.FILE_URI,
        destinationType: Camera.DestinationType.DATA_URL,
        sourceType: srcType,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: false,
        correctOrientation: true, //Corrects Android orientation quirks
        targetWidth: 1500,
        targetHeight: 1500
    };
    return options;
};

CameraHelper.setMediaOptions = mediaType => {
    const Camera = window.Camera;
    const options = {
        // Some common settings are 20, 50, and 100
        quality: 80,
        //destinationType: Camera.DestinationType.FILE_URI,
        destinationType: Camera.DestinationType.DATA_URL,
        sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: mediaType,
        allowEdit: false,
        correctOrientation: true, //Corrects Android orientation quirks
        targetWidth: 1500,
        targetHeight: 1500
    };
    return options;
};

CameraHelper.getFileEntry = (imageUri, callbackFn) => {
    window.resolveLocalFileSystemURL(
        imageUri,
        function success(fileEntry) {
            fileEntry.file(function(fileData) {
                callbackFn(fileData);
            });
        },
        e => {
            //console.error('file upload error', e);
            LogManager.sendLog(e);
        }
    );
};

CameraHelper.getImage = (callbackFn, failcb) => {
    const Camera = window.Camera;
    if (!Camera) return;
    navigator.camera.cleanup();
    navigator.camera.getPicture(
        // 사진 가져오기에 성공한 경우 호출될 함수
        imageUri => {
            if (!imageUri) return '';
            callbackFn('data:image/jpeg;base64,' + imageUri);
        },
        // 사진 가져오기에 실패한 경우 호출될 함수
        err => {
            failcb(err);
        },
        // 카메라,갤러리 호출 옵션
        CameraHelper.setMediaOptions(Camera.MediaType.PICTURE)
    );
};

CameraHelper.getVideo = (callbackFn, failcb) => {
    const Camera = window.Camera;
    if (!Camera) return;
    navigator.camera.cleanup();
    navigator.camera.getPicture(
        // 사진 가져오기에 성공한 경우 호출될 함수
        uri => {
            if (!uri) return '';
            callbackFn('file:' + uri);
        },
        // 사진 가져오기에 실패한 경우 호출될 함수
        err => {
            failcb(err);
        },
        // 카메라,갤러리 호출 옵션
        CameraHelper.setMediaOptions(Camera.MediaType.VIDEO)
    );
};

CameraHelper.getPicture = (sourceType, callbackFn, failcb) => {
    const Camera = window.Camera;
    if (!Camera) return;
    const PictureSourceType =
        sourceType === 0 ? Camera.PictureSourceType.PHOTOLIBRARY : Camera.PictureSourceType.CAMERA;
    navigator.camera.cleanup();
    navigator.camera.getPicture(
        // 사진 가져오기에 성공한 경우 호출될 함수
        imageUri => {
            if (!imageUri) return '';
            callbackFn('data:image/jpeg;base64,' + imageUri);
        },
        // 사진 가져오기에 실패한 경우 호출될 함수
        err => {
            failcb(err);
        },
        // 카메라,갤러리 호출 옵션
        CameraHelper.setOptions(PictureSourceType)
    );
};
export default CameraHelper;
